module.exports = __webpack_public_path__ + "img/image11.d231d571.png";